import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { typeLabel } from '../../utils/categoricalColors';
import { formatDecimal1, formatInt } from '../../utils/numberFormat';

const NUMERICA = { align: 'right', sx: { fontVariantNumeric: 'tabular-nums' } };

/**
 * Gli stessi dati delle barre, in tabella, con la riga di totale: serve a verificare un numero.
 * Il totale della colonna «Pagine» deve coincidere con la KPI in testa alla pagina — se non coincide
 * è un difetto, non un arrotondamento.
 */
const UsageTypeTable = ({ rows }) => {
  const totalePagine = rows.reduce((acc, row) => acc + row.pages, 0);
  const totaleDocumenti = rows.reduce((acc, row) => acc + row.documents, 0);
  const media = totaleDocumenti > 0 ? totalePagine / totaleDocumenti : 0;

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Tipo di documento</TableCell>
          <TableCell align="right">Documenti</TableCell>
          <TableCell align="right">Pagine</TableCell>
          <TableCell align="right">Media</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.codexTypeId ?? 'senza-tipo'} hover>
            <TableCell>{typeLabel(row)}</TableCell>
            <TableCell {...NUMERICA}>{formatInt(row.documents)}</TableCell>
            <TableCell {...NUMERICA}>{formatInt(row.pages)}</TableCell>
            <TableCell {...NUMERICA}>{formatDecimal1(row.avgPagesPerDocument)}</TableCell>
          </TableRow>
        ))}
        {!rows.length && (
          <TableRow>
            <TableCell colSpan={4}>
              <Typography color="text.secondary">Nessun dato nel periodo selezionato</Typography>
            </TableCell>
          </TableRow>
        )}
      </TableBody>

      <TableFooter>
        <TableRow>
          <TableCell sx={{ fontWeight: 700, color: 'text.primary' }}>Totale</TableCell>
          <TableCell {...NUMERICA} sx={{ ...NUMERICA.sx, fontWeight: 700, color: 'text.primary' }}>
            {formatInt(totaleDocumenti)}
          </TableCell>
          <TableCell {...NUMERICA} sx={{ ...NUMERICA.sx, fontWeight: 700, color: 'text.primary' }}>
            {formatInt(totalePagine)}
          </TableCell>
          <TableCell {...NUMERICA} sx={{ ...NUMERICA.sx, color: 'text.primary' }}>
            {formatDecimal1(media)}
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  );
};

export default UsageTypeTable;
